import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/types';
import { Card } from 'ui-toolkit/index';
import { loadConversationsAction } from '../../store/conversations/conversationsSlice';
import { ConversationsDataGrid } from '../../components/conversations/ConversationsDataGrid';
import { IConversationOrderData, IConversationQuery } from '../../types/conversations/IConversation';
import { DeleteConversationOrderModalContainer } from '../../components/conversations/DeleteConversationOrderModalContainer';
import { EditConversationOrderModal } from '../../components/conversations/EditConversationOrderModal';
import { setConversationOrder } from '../../store/conversations/conversationOrderSlice';
import { eSideDrawerContentType } from '../../types/sideDrawer/eSideDrawerContentType';
import { saveConversationSlice } from '../../store/conversations/saveConversationSlice';
import { useAppDispatch } from '../../store/store';

interface IConversationsContainerProps {
  orderId: string;
}

export const ConversationsContainer: React.FC<IConversationsContainerProps> = ({ orderId }) => {
  const dispatch = useAppDispatch();
  const [deletedConversationOrder, setDeletedConversationOrder] = useState<IConversationOrderData | undefined>(
    undefined
  );
  const [query, setQuery] = useState<IConversationQuery>({
    orderId,
    sortField: 'createdAt',
    sortOrder: 'desc',
    contactType: undefined,
    pageNumber: 1,
    pageSize: 10,
  });

  const { data: conversations } = useSelector((state: RootStore) => state.conversations.conversations);
  const { data: editedConversationOrder } = useSelector((state: RootStore) => state.conversations.conversationOrder);
  const { contentType } = useSelector((state: RootStore) => state.sideDrawer);
  const sideDrawerOpen = contentType === eSideDrawerContentType.Conversation;

  useEffect(() => {
    dispatch(loadConversationsAction({ ...query, contactType: undefined }));
  }, [dispatch, orderId, query]);

  const setEditedConversationOrder = (conversationOrder: IConversationOrderData) => {
    dispatch(setConversationOrder({ ...conversationOrder, orderId }));
  };

  const onCloseDeleteConversationModal = () => {
    setDeletedConversationOrder(undefined);
  };

  const onDeleteConversationOrder = () => {
    dispatch(loadConversationsAction({ ...query, contactType: undefined }));
  };

  const onCloseEditConversationModal = () => {
    dispatch(saveConversationSlice.actions.reset({}));
    dispatch(setConversationOrder(undefined));
    dispatch(loadConversationsAction({ ...query, contactType: undefined }));
  };

  return (
    <Card title="Conversations">
      <ConversationsDataGrid
        conversations={conversations}
        editingEnabled={!sideDrawerOpen}
        query={query}
        setQuery={setQuery}
        onDeleteClick={setDeletedConversationOrder}
        onEditClick={setEditedConversationOrder}
      />
      {deletedConversationOrder && (
        <DeleteConversationOrderModalContainer
          genesysId={deletedConversationOrder.genesysId}
          orderId={orderId}
          onClose={onCloseDeleteConversationModal}
          onSuccess={onDeleteConversationOrder}
        />
      )}
      {editedConversationOrder && !sideDrawerOpen && (
        <EditConversationOrderModal
          conversationOrder={editedConversationOrder}
          orderId={orderId}
          onClose={onCloseEditConversationModal}
        />
      )}
    </Card>
  );
};
